import { html } from "lit";

export const Template = ({ ctaLabel, text }) => html`
    <ux-iws-sf-cta-footer>
        <div slot="text">${text}</div>
        <div slot="cta">
            <ux-button variant="primary" href="#" aria-label="${ctaLabel}">
                ${ctaLabel}
            </ux-button>
        </div>
    </ux-iws-sf-cta-footer>
`;
